<template>
    <div id="container-card" :class="[dataType == 'big-news' ? ['h-card-big', 'overflow-hidden'] : [dataType == 'small-news' ? 'h-card-small' : [dataType == 'store' ? ['h-store-card', 'pb-special', 'bg-white', 'shadow-card-v2', 'shadow-black-12', 'dark:shadow-black-100/20', 'dark:bg-primary-dark-color-4th', 'max-md:h-card-small'] : '']]]" class="rounded-smoth relative hover:cursor-pointer" @click="preview()">
        <div id="container-photo" :class="[dataType == 'big-news' ? 'h-full ' : dataType == 'store' ? 'h-3/5' : 'h-3/4']" class="relative rounded-t-smoth overflow-hidden w-full">
            <img :src="data['url']" :alt="'IMAGEN DE ' + data['name']" class="w-full h-full object-cover" loading="lazy">
        </div>
        <div id="container-body-card" :class="[dataType == 'big-news' ? ['bg-news-data', 'absolute', 'bottom-0', 'text-white'] : dataType == 'store' ? 'h-2/5' : 'h-max']" class="py-body-new px-special w-full rounded-smoth flex flex-col justify-between">
            <div id="container-title" :class="[dataType == 'store' ? ['text-secondary-color-3rd', 'mt-min'] : '']" class="flex flex-col justify-between">
                <span class="font-bloggerB" :class="[dataType == 'store' ? ['text-principal-desktop', 'max-md:text-content-subtitle-mobile', 'text-black-100', 'dark:text-primary-dark-text'] : dataType == 'big-news' ? ['text-content-title-desktop', 'max-md:text-content-title-mobile'] : ['text-principal-desktop', 'max-md:text-principal-mobile', 'dark:text-primary-dark-text']]">
                    {{ data['name'] }}
                </span>
                <span v-if="dataType == 'store'" class="w-fit py-min px-middle rounded-full bg-primary-color-1st text-white mt-min text-ticket-desktop font-monserratM dark:text-primary-dark-text dark:bg-primary-dark-color-1st max-md:text-ticket-mobile">
                    {{ data['cat'] }}
                </span>
            </div>
            <div id="container-sub-data" class="flex flex-col justify-between leading-6">
                <span :class="[dataType == 'store' ? ['text-primary-color-1st', 'font-extrabold', 'text-big-text-desktop', 'font-bloggerB', 'max-md:text-big-text-mobile', 'dark:text-secondary-color-1st'] : ['text-ticket-desktop', 'font-monserratM', 'max-md:text-ticket-mobile', 'dark:text-primary-dark-text']]">
                    {{ date || 'L. ' + data['price'].replace('$', '') }}
                </span>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, watchEffect } from 'vue';
import router from '@/router';
import { generalStore } from '@/stores';
import { newStore } from '@/stores/news';
import { productStore } from '@/stores/product';

const store = generalStore();
const storeP = productStore();
const storeN = newStore();
const route = store.route;
const props = defineProps([
    'data',
    'dataType'
]);

var date = ref('')


watchEffect(() => {
    if (props['data']) {
        if (route.name == 'News') {
            date.value = new Date(props.data['date']).toLocaleDateString('es-es', { weekday: "long", year: "numeric", month: "long", day: "numeric" });
        }
    }
})

/**
 * Function used to set the detail of the selected product to show the modal with the selected product
 */
const preview = async () => {
    if (route.name == 'Store') {
        props.data['size'] = null
        props.data['idSize'] = null
        storeP.setDetailProduct(props.data)
        router.push({ name: 'ModalT', params: { 'id': props.data['id'], 'detailData': props.data['name'], 'color': props.data['color'] } })
    } else if (route.name == 'News') {
        storeN.setDetailNew(props.data)
        await storeN.getDetailNews(props.data['id']);
        router.push({ name: 'Preview', params: { 'id': props.data['id'], 'name': props.data['name'] } });
        await storeN.registerClick(props.data['id']);
    }
}

</script>